import { render, staticRenderFns } from "./CommentsTimeline.vue?vue&type=template&id=03be050f&scoped=true&lang=pug"
import script from "./CommentsTimeline.vue?vue&type=script&lang=js"
export * from "./CommentsTimeline.vue?vue&type=script&lang=js"
import style0 from "./CommentsTimeline.vue?vue&type=style&index=0&id=03be050f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03be050f",
  null
  
)

export default component.exports